import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

const ContactMe = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_df2dzah', 'template_209gs97', form.current, '2N5k9-epEATKQKeQH')
          .then((result) => {
              console.log(result.text);
              window.location.reload();
          }, (error) => {
              console.log(error.text);
          });
      };
    return (
        <div id='contactMe' class="hero min-h-screen py-10 bg-base-200">
  <div class="hero-content flex-col lg:flex-row">
    <div class="flex-1 text-center lg:text-left lg:pr-12">
      <h1 class="text-5xl font-bold">Have you any question?</h1>
      <p className='py-6 text-4xl text-yellow-600'>Feel Free to Ask</p>
      
    </div>
    <div class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100">
    <div className='card-body '>
    <form ref={form} onSubmit={sendEmail}>
            <input type="name" name='name' placeholder="Name" className='input input-bordered input-secondary w-full max-w-md' required />
            <br />
            <br />
            <input type="email" name='email' placeholder="Email" className='input input-bordered input-secondary w-full max-w-md' required />
            <br />
            <br />
            <input type="text" name='subject' placeholder="Subject" className='input input-bordered input-secondary w-full max-w-md' required />
            <br />
            <br />
            <textarea className='textarea input-bordered input-secondary w-full max-w-md' placeholder='Your message' name="message" id="" cols="50" rows="6" required></textarea>
            <br />
            <br />
            <div className='flex justify-center'>
            <input className='btn btn-primary text-white font-bold' type="submit" value="Submit" />
            </div>

            </form>
    </div>
    
    </div>
  </div>
</div>
        
           
            
           
      
    );
};

export default ContactMe;